import {
  ITEM_CARD_NARRATIVE_LIST_VIEW,
  ITEM_CARD_SEQUENCE_LIST_VIEW,
  NARRATIVE_VIEW,
  TIMELINE_VIEW
} from "../constants/identifiers";
import interfaceUserActions from "../constants/interfaceUserActions";
import { appStateOperations } from "./appState";
import batchUtils from "./batchUtils";
import { batchActions } from "./chainReducer";
import { definitionOperations } from "./definition";
import { typeOperations } from "./definition/types";
import { uiStateOperations } from "./uiState";

// Create a new batch action by adding more actions to a batch

const openSearch = () => {
  return batchActions([appStateOperations.openSearchPanel(), uiStateOperations.collapseSearchReplace()]);
};

const applySettings = definitions => {
  let typeActions = [];
  // And then we need to replace defs and hide settings as normal
  const replaceDefs = definitionOperations.replaceDefinitions(definitions);
  const hideSettings = uiStateOperations.hideSettingsModal();
  return batchUtils.batchWithAppendedActions(batchActions(typeActions), [replaceDefs, hideSettings]);
};

const hideLeftPanelAndClearSelection = () => {
  const hideAction = appStateOperations.hideLeftPanel();
  const clearAction = appStateOperations.clearSelection();
  return batchActions([hideAction, clearAction]);
};

const showEntityListAndClearSelection = typeId => {
  const showListAction = appStateOperations.openEntityList(typeId);
  const clearAction = appStateOperations.clearSelection();
  return batchActions([showListAction, clearAction]);
};

const setLeftPanelModeAndClearSelection = mode => {
  const setAction = appStateOperations.setLeftPanelMode(mode);
  const clearAction = appStateOperations.clearSelection();
  return batchActions([setAction, clearAction]);
};

const switchMobileToTimeline = () => {
  const portraitAction = appStateOperations.switchMobilePortraitViewType(ITEM_CARD_SEQUENCE_LIST_VIEW);
  const landscapeAction = appStateOperations.switchViewType(TIMELINE_VIEW, null);
  const interfaceAction = appStateOperations.userInterfaceActionPerformed(interfaceUserActions.SWITCH_MOBILE_VIEW);
  return batchActions([portraitAction, landscapeAction, interfaceAction]);
};

const switchMobileToNarrative = () => {
  const portraitAction = appStateOperations.switchMobilePortraitViewType(ITEM_CARD_NARRATIVE_LIST_VIEW);
  const landscapeAction = appStateOperations.switchViewType(NARRATIVE_VIEW, null);
  const interfaceAction = appStateOperations.userInterfaceActionPerformed(interfaceUserActions.SWITCH_MOBILE_VIEW);
  return batchActions([portraitAction, landscapeAction, interfaceAction]);
};

const switchMobileToEntityList = typeId => {
  const switchAction = appStateOperations.switchMobilePortraitViewType(typeId);
  const listAction = appStateOperations.openEntityList(typeId);
  const interfaceAction = appStateOperations.userInterfaceActionPerformed(interfaceUserActions.SWITCH_MOBILE_VIEW);
  return batchActions([switchAction, listAction, interfaceAction]);
};

const closeMobileInspectorAndClearSelection = () => {
  const closeAction = appStateOperations.closeIosInspectorPanel();
  const clearAction = appStateOperations.clearSelection();
  return batchActions([closeAction, clearAction]);
};

const hideInspectorModalAndClearSelection = () => {
  const closeAction = uiStateOperations.hideInspectorModal();
  const clearAction = appStateOperations.clearSelection();
  return batchActions([closeAction, clearAction]);
};

export const enableAndIncludeNarrativeType = (includeNarrative, defaultNarrativeDocumentType, defaultSequenceType) => {
  let actions = [];
  // Make sure at least one item type is allowed in narrative
  if (includeNarrative && !defaultNarrativeDocumentType) {
    const changeIncludeInNarrative = typeOperations.changeIncludeInNarrative(defaultSequenceType, true);
    actions.unshift(changeIncludeInNarrative);
  }
  return actions;
};

// So far this is used for V2 converting
const changeIncludeNarrativeAndIncludeType = (includeNarrative, defaultNarrativeDocumentType, defaultSequenceType) => {
  const narrativeAction = definitionOperations.changeIncludeNarrative(includeNarrative);
  const typeActions = enableAndIncludeNarrativeType(
    includeNarrative,
    defaultNarrativeDocumentType,
    defaultSequenceType
  );
  const actions = [narrativeAction].concat(typeActions);
  return batchActions(actions);
};

export default {
  openSearch,
  applySettings,
  hideLeftPanelAndClearSelection,
  showEntityListAndClearSelection,
  setLeftPanelModeAndClearSelection,
  switchMobileToTimeline,
  switchMobileToNarrative,
  switchMobileToEntityList,
  closeMobileInspectorAndClearSelection,
  hideInspectorModalAndClearSelection,
  changeIncludeNarrativeAndIncludeType
};
